import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth.store';
import { LoadingPanel } from '@/components/ui/Spinner';

/**
 * Gate for every signed-in-only route (dashboard, new analysis, projects,
 * history, settings). A guest is bounced to the front page rather than shown
 * an empty or broken screen; `from` lets the front page's sign-in flow
 * return them to where they were headed once we have a post-login redirect.
 *
 * While the session restore is still in flight ('loading'), this renders a
 * spinner instead of redirecting - otherwise a signed-in user refreshing a
 * protected page would flash through the guest redirect before their
 * session finishes loading.
 */
export function RequireAuth() {
  const status = useAuthStore((state) => state.status);
  const location = useLocation();

  if (status === 'loading') {
    return <LoadingPanel label="Checking your session" />;
  }

  if (status === 'guest') {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
